// extracted by mini-css-extract-plugin
module.exports = {"positions":"Positions_positions__h72pe","container":"Positions_container__P4ftE","firstCol":"Positions_firstCol__Gh24P","secondCol":"Positions_secondCol__b6zd5"};